export default __webpack_public_path__ + "static/napolean-9fb2a8af9bd6fb4b55c7db2a872c1da4.webp";